function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { addRUMTiming } from '@noths/polaris-client-utils';
import { R3_COMMON } from "./rrJsonApi/rrFacade";
var ALGONOMY_REQUEST_TIMEOUT_IN_MS = 5000;

/**
 * When all packages and apps are migrated to use this package, we should change this function to return the data
 * in a different format to RichRelevancePlacement. Only this package should use RR-specific types.
 */
export var getRecommendations = function getRecommendations(placementNames) {
  window.RR.renderDynamicPlacements = null;
  placementNames.forEach(function (placementName) {
    R3_COMMON().addPlacementType(placementName);
  });
  window.rr_flush_onload();
  addRUMTiming('rrRequestStart');
  var rrRequestStart = Date.now();
  var timeout = setTimeout(function () {
    addRUMTiming('rrCallbackTimeout');
  }, ALGONOMY_REQUEST_TIMEOUT_IN_MS);
  return new Promise(function (resolve) {
    window.RR.jsonCallback = function () {
      var _window$RR$data$JSON$, _window$RR$data;
      var fetchedPlacements = (_window$RR$data$JSON$ = (_window$RR$data = window.RR.data) === null || _window$RR$data === void 0 || (_window$RR$data = _window$RR$data.JSON) === null || _window$RR$data === void 0 ? void 0 : _window$RR$data.placements) !== null && _window$RR$data$JSON$ !== void 0 ? _window$RR$data$JSON$ : [];
      if (fetchedPlacements.length === 0) {
        addRUMTiming('rrAllPlacementDataMissing');
      } else if (fetchedPlacements.length === placementNames.length) {
        addRUMTiming('rrAllPlacementDataPresent');
      } else {
        addRUMTiming('rrPartialPlacementDataPresent');
      }
      var placementData = placementNames.reduce(function (placements, placementName) {
        var placement = fetchedPlacements.find(function (pl) {
          return pl.placement_name === placementName;
        });
        return placement ? [].concat(_toConsumableArray(placements), [placement]) : placements;
      }, []);
      clearTimeout(timeout);
      addRUMTiming('rrCallbackSuccess');
      addRUMTiming('rrResponseDelta', rrRequestStart);
      resolve(placementData);
    };
    window.r3();
  });
};
export var sendRecommendationsPageData = function sendRecommendationsPageData() {
  var pagePlacements = {
    R3_CART: 'cart_page',
    R3_CATEGORY: 'category_page',
    R3_ERROR: 'error_page',
    R3_HOME: 'home_page',
    R3_PURCHASED: 'purchase_complete_page'
  };
  for (var _i = 0, _Object$entries = Object.entries(pagePlacements); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      pageType = _Object$entries$_i[0],
      placementType = _Object$entries$_i[1];
    if (window[pageType]) {
      R3_COMMON().addPlacementType(placementType);
    }
  }
  window.rr_flush_onload();
  return new Promise(function (resolve) {
    window.RR.jsonCallback = function () {
      resolve();
    };
    window.r3();
  });
};